import React from "react";

import BcSepIcon from "../../asset/images/about/breadcrumb-separator.svg";
import ThumbsIcon from "../../asset/images/products/vedika-20khz/thumbs-icon.svg";

// Desktop + Mobile hero images — imported separately
import HeroBgImg       from "../../asset/images/products/vedika-20khz/hero-bg.webp";
import HeroBgImgMobile from "../../asset/images/products/vedika-20khz/hero-bg-mobile.webp";

// Three step images
import StepImg1 from "../../asset/images/products/vedika-20khz/step-1.webp";
import StepImg2 from "../../asset/images/products/vedika-20khz/step-2.webp";
import StepImg3 from "../../asset/images/products/vedika-20khz/step-3.webp";


const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .v20-wrap { font-family: 'Poppins', sans-serif; color: #202020; background: #fff; }

  /* ══════════════════════════════════════════
     1. HERO
  ══════════════════════════════════════════ */
  .v20-hero {
    position: relative;
    width: 100%;
    height: 460px;
    overflow: hidden;
    background: #111;
  }
  .v20-hero-bg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: block;
  }
  .v20-hero-bg-mobile {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: none;
  }
  .v20-hero-overlay {
    position: absolute;
    inset: 0;
  }
  .v20-hero-content {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 102px;
    max-width: 1600px;
    margin: 0 auto;
    left: 0; right: 0;
  }
  .v20-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px;
    font-weight: 600;
    color: #fff;
    line-height: 120%;
    margin-bottom: 15px;
  }
  .v20-hero-divider {
    width: 429px;
    height: 2px;
    background: #EB2019;
    border: none;
    margin-bottom: 18px;
  }
  .v20-hero-desc {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 140%;
    max-width: 429px;
  }

  /* ══════════════════════════════════════════
     2. BREADCRUMB
  ══════════════════════════════════════════ */
  .v20-breadcrumb {
    padding: 40px 0 0 0;
  }
  .v20-breadcrumb-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 14px;
  }
  .v20-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #202020;
    text-decoration: none;
    transition: color 0.15s;
  }
  .v20-bc-item:hover { color: #EB2019; }
  .v20-bc-item.v20-active { color: #202020; }
  .v20-bc-sep {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    margin: 0 8px;
    flex-shrink: 0;
  }

  /* ══════════════════════════════════════════
     SHARED INNER
  ══════════════════════════════════════════ */
  .v20-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
  }

  /* ══════════════════════════════════════════
     3. INTRO — red title + bold subtitle + red tag
  ══════════════════════════════════════════ */
  .v20-intro {
    padding: 80px 0 60px 0;
  }
  .v20-red-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px;
    font-weight: 600;
    color: #EB2019;
    margin-bottom: 14px;
    line-height: 120%;
  }
  .v20-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-weight: 600;
    color: #202020;
    margin-bottom: 14px;
  }
  .v20-red-tag {
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-weight: 400;
    color: #EB2019;
    display: block;
  }

  /* ══════════════════════════════════════════
     4. THREE STEP IMAGES ROW
  ══════════════════════════════════════════ */
  .v20-steps {
    padding: 0 0 24px 0;
  }
  .v20-steps-grid {
    display: flex;
    align-items: center;
  }
  .v20-step-img-wrap {
    flex: 1;
    overflow: hidden;
  }
  .v20-step-img {
    width: 100%;
    height: 383px;
    object-fit: cover;
    display: block;
    border-radius: 10px;
  }
  .v20-arrow-btn {
    flex-shrink: 0;
    width: 44px;
    height: 44px;
    background: #EB2019;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 32px;
  }
  .v20-arrow-btn svg {
    width: 22px;
    height: 22px;
  }

  /* ══════════════════════════════════════════
     5. DESCRIPTION PARAGRAPHS
  ══════════════════════════════════════════ */
  .v20-desc-block {
    padding: 0 0 0px 0;
  }
  .v20-para {
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-weight: 400;
    color: #202020;
    line-height: 140%;
  }
  .v20-para + .v20-para { margin-top: 14px; }
  .v20-para b { font-weight: 600; }
  .v20-red-link {
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-weight: 400;
    color: #EB2019;
    text-decoration: none;
    display: inline-block;
    margin-top: 44px;
  }
  .v20-red-link:hover { text-decoration: underline; }

  /* ══════════════════════════════════════════
     6. FEATURE BLOCKS
  ══════════════════════════════════════════ */
  .v20-feature-block {
    padding: 60px 0 0 0;
  }
  .v20-feature-heading-row {
    display: flex;
    align-items: center;
    gap: 24px;
    margin-bottom: 14px;
  }
  .v20-thumbs-icon {
    width: 44px;
    height: 44px;
    flex-shrink: 0;
    display: block;
  }
  .v20-feature-heading {
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-weight: 500;
    color: #202020;
  }
  .v20-feature-desc {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #202020;
    line-height: 160%;
    margin-bottom: 60px;
  }
  .v20-feature-desc b { font-weight: 700; }

  /* ══════════════════════════════════════════
     7. COMPARISON TABLE
  ══════════════════════════════════════════ */
  .v20-table-wrap {
    border: 1px solid #B8B8B8;
    overflow: hidden;
    margin-bottom: 60px;
  }
  .v20-table-wrap:last-child {
    border: 1px solid #B8B8B8;
    overflow: hidden;
    margin-bottom: 120px;
  }
  .v20-table {
    width: 100%;
    border-collapse: collapse;
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    color: #202020;
  }

  /* Header row */
  .v20-table thead tr {
    background: #F6F6F6;
  }
  .v20-table thead th {
    padding: 28px 24px;
    font-weight: 600;
    text-align: left;
    font-size: 20px;
    border-bottom: 1px solid #B8B8B8;
    border-right: 1px solid #B8B8B8;
  }
  .v20-table thead th:first-child { border-right: none; }
  .v20-table thead th:last-child { border-right: none; }
  /* first two empty header cells */
  .v20-table thead th:first-child,
  .v20-table thead th:nth-child(2) { width: 180px; }

  /* Body rows */
  .v20-table tbody tr {
    border-bottom: 1px solid #D9D9D9;
  }
  .v20-table tbody tr:last-child { border-bottom: none; }
  .v20-table tbody td {
    padding: 28px 24px;
    border-right: 1px solid #B8B8B8;
    vertical-align: middle;
    font-size: 20px;
    font-weight: 400;
  }
  .v20-table tbody td:last-child { border-right: none; }

  /* Merged row-label cell */
  .v20-td-rowlabel {
    text-align: center;
    font-weight: 400;
    width: 180px;
    background: #fff;
    border-right: 1px solid #B8B8B8;
  }
  .v20-td-rowlabel-noborder {
    text-align: center;
    font-weight: 400;
    width: 180px;
    background: #fff;
    border-right: 1px solid #B8B8B8;
    border-bottom: none;
  }
  /* Sub-label cell */
  .v20-td-sublabel {
    text-align: center;
    width: 180px;
    font-size: 20px;
    background: #fff;
    font-weight: 400;
  }
  /* Alternating row backgrounds */
  .v20-table tbody tr:nth-child(even) td { background: #F6F6F6; }
  .v20-table tbody tr:nth-child(even) .v20-td-rowlabel { background: #fff; }
  .v20-table tbody tr:nth-child(even) .v20-td-sublabel { background: #F6F6F6; }

  /* ══════════════════════════════════════════
     RESPONSIVE — TABLET 768px
  ══════════════════════════════════════════ */
  @media (max-width: 768px) {
    .v20-hero              { height: 300px; }
    .v20-hero-bg           { display: block; }
    .v20-hero-bg-mobile    { display: none; }
    .v20-hero-content      { padding: 0 32px; }
    .v20-hero-title        { font-size: 30px; }
    .v20-hero-divider      { width: 290px; }
    .v20-hero-desc         { font-size: 14px; max-width: 290px; }

    .v20-breadcrumb        { padding: 28px 0 0 0; }
    .v20-breadcrumb-inner  { padding: 0 32px; }
    .v20-inner             { padding: 0 32px; }
    .v20-para + .v20-para  { margin-top: 10px; }
    .v20-red-link          { margin-top: 24px; }
    .v20-feature-block     { padding: 40px 0 0 0; }
    .v20-table-wrap        { margin-bottom: 40px; }
    .v20-table-wrap:last-child { margin-bottom: 40px; }

    .v20-intro             { padding: 40px 0 30px 0; }
    .v20-red-title         { font-size: 24px; }
    .v20-subtitle          { font-size: 17px; }
    .v20-red-tag           { font-size: 16px; }

    .v20-step-img          { height: 220px; }
    .v20-arrow-btn         { width: 40px; height: 40px; margin: 0 12px; }
    .v20-arrow-btn svg     { width: 16px; height: 16px; }

    .v20-para              { font-size: 14px; }
    .v20-red-link          { font-size: 14px; }
    .v20-feature-heading-row { gap: 20px; }

    .v20-feature-heading   { font-size: 18px; }
    .v20-feature-desc      { font-size: 14px; margin-bottom: 24px; }
    .v20-thumbs-icon       { width: 36px; height: 36px; }

    .v20-table             { font-size: 14px; }
    .v20-table thead th    { padding: 14px 16px; font-size: 16px; }
    .v20-table tbody td    { padding: 14px 16px; font-size: 14px; }
  }

  /* ══════════════════════════════════════════
     RESPONSIVE — MOBILE 480px
  ══════════════════════════════════════════ */
  @media (max-width: 480px) {
    .v20-hero              { height: 400px; }
    .v20-hero-bg           { display: none; }
    .v20-hero-bg-mobile    { display: block; }
    .v20-hero-content      { padding: 0 16px; }
    .v20-hero-title        { font-size: 24px; }
    .v20-hero-divider      { width: 100%; margin-bottom: 15px; }
    .v20-hero-desc         { font-size: 14px; }

    .v20-breadcrumb        { padding: 30px 0 0 0; }
    .v20-breadcrumb-inner  { padding: 0 16px; gap: 14px; }
    .v20-bc-item           { font-size: 14px; }
    .v20-bc-sep            { width: 18px; height: 18px; margin: 0 4px; }
    .v20-inner             { padding: 0 16px; }

    .v20-intro             { padding: 30px 0 20px 0; }
    .v20-red-title         { font-size: 20px; margin-bottom: 20px; }
    .v20-subtitle          { font-size: 16px; }
    .v20-red-tag           { font-size: 16px; margin-bottom: 20px; }

    .v20-steps-grid        { flex-direction: column; gap: 30px; }
    .v20-arrow-btn         { transform: rotate(90deg); margin: 0; width: 44px; height: 44px; }
    .v20-step-img          { height: 359px; width: 100%; }
    .v20-steps             { padding: 0 0 20px 0; }
    .v20-para + .v20-para  { margin-top: 16px; }

    .v20-para              { font-size: 14px; }
    .v20-red-link          { font-size: 14px; margin-top: 16px; }
    .v20-feature-block     { padding: 60px 0 0 0; }

    .v20-feature-heading   { font-size: 18px; }
    .v20-feature-heading-row { margin-bottom: 18px; }
    .v20-feature-desc      { font-size: 14px; margin-bottom: 15px; }
    .v20-thumbs-icon       { width: 44px; height: 44px; }

    /* Table — no horizontal scroll, text wraps naturally like screenshot */
    .v20-table-wrap        { overflow: hidden; margin-bottom: 32px; }
    .v20-table             { font-size: 13px; width: 100%; }
    .v20-table thead th    { padding: 12px 8px; font-size: 13px; }
    .v20-table tbody td    { padding: 14px 8px; font-size: 13px; }
    .v20-table thead th:first-child,
    .v20-table thead th:nth-child(2) { width: auto; }
    .v20-td-rowlabel       { width: auto; }
    .v20-td-sublabel       { width: auto; }
    .v20-td-rowlabel-noborder { width: auto; }
  }
`;

export default function Vedika20kHz() {
  return (
    <div className="v20-wrap">
      <style>{CSS}</style>

      {/* ══ 1. HERO ══ */}
      <section className="v20-hero">
        <img className="v20-hero-bg"        src={HeroBgImg}       alt="" />
        <img className="v20-hero-bg-mobile" src={HeroBgImgMobile} alt="" />
        <div className="v20-hero-overlay" />
        <div className="v20-hero-content">
          <h1 className="v20-hero-title">Vedika 2.0 &gt; 20 KHz</h1>
          <hr className="v20-hero-divider" />
          <p className="v20-hero-desc">
            He GEN next high frequency supply for best performance of ESP
          </p>
        </div>
      </section>

      {/* ══ 2. BREADCRUMB ══ */}
      <nav className="v20-breadcrumb" aria-label="Breadcrumb">
        <div className="v20-breadcrumb-inner">
          <a href="/"         className="v20-bc-item">Home</a>
          <span className="v20-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/products" className="v20-bc-item">Products</a>
          <span className="v20-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/products/hfps" className="v20-bc-item">HFPS</a>
          <span className="v20-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="v20-bc-item v20-active">Vedika 2.0 &gt; 20 KHz</span>
        </div>
      </nav>

      {/* ══ 3. INTRO ══ */}
      <section className="v20-intro">
        <div className="v20-inner">
          <h2 className="v20-red-title">Vedika 2.0 &gt; 20 KHz</h2>
          <h3 className="v20-subtitle">He GEN Next High Frequency Supply For Best Performance Of ESP</h3>
          <span className="v20-red-tag">Easy to Install</span>
        </div>
      </section>

      {/* ══ 4. THREE STEP IMAGES ══ */}
      <section className="v20-steps">
        <div className="v20-inner">
          <div className="v20-steps-grid">

            <div className="v20-step-img-wrap">
              <img className="v20-step-img" src={StepImg1} alt="Installation step 1" />
            </div>

            {/* Arrow 1 */}
            <div className="v20-arrow-btn">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 12H19M13 6L19 12L13 18" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>

            <div className="v20-step-img-wrap">
              <img className="v20-step-img" src={StepImg2} alt="Installation step 2" />
            </div>

            {/* Arrow 2 */}
            <div className="v20-arrow-btn">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 12H19M13 6L19 12L13 18" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>

            <div className="v20-step-img-wrap">
              <img className="v20-step-img" src={StepImg3} alt="Installation step 3" />
            </div>

          </div>
        </div>
      </section>

      {/* ══ 5. DESCRIPTION ══ */}
      <section className="v20-desc-block">
        <div className="v20-inner">
          <p className="v20-para">
            The 5th generation High frequency power supply of ESP– constant- high- frequency electrostatic power source, is the only one company in the world with 93%-efficiency.
          </p>
          <p className="v20-para">
            This <b>5th generation</b> High frequency power supply of ESP with voltage of 72-120kV, constant frequency and PF of 0.99 and efficiency of 93%.
          </p>
          <p className="v20-para">
            &nbsp;A Higher Amplitude of KV and mA always helps in best performance of ESP
          </p>
          <p className="v20-red-link">
            Technical comparison from any other High frequency
          </p>
        </div>
      </section>

      {/* ══ 6. HIGHER EFFICIENCY ══ */}
      <section className="v20-feature-block" id="comparison">
        <div className="v20-inner">

          {/* Heading row */}
          <div className="v20-feature-heading-row">
            <img src={ThumbsIcon} alt="" className="v20-thumbs-icon" />
            <h4 className="v20-feature-heading">Higher  efficiency</h4>
          </div>
          <p className="v20-feature-desc">
            The efficiency of 93% is 8% higher than any other high frequency devise (85%) at operating load
          </p>

          {/* Conversion Efficiency Table */}
          <div className="v20-table-wrap">
            <table className="v20-table">
              <thead>
                <tr>
                  <th></th>
                  <th></th>
                  <th>Other High Frequency</th>
                  <th>Ador 5th Gen High Frequency</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="v20-td-rowlabel-noborder">Conversion</td>
                  <td className="v20-td-sublabel">Full Load</td>
                  <td>85.0%</td>
                  <td>93.4%</td>
                </tr>
                <tr>
                  <td className="v20-td-rowlabel">Efficiency</td>
                  <td className="v20-td-sublabel">Half Load</td>
                  <td>75.1%</td>
                  <td>91.7%</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Better Power Factor heading */}
          <div className="v20-feature-heading-row">
            <img src={ThumbsIcon} alt="" className="v20-thumbs-icon" />
            <h4 className="v20-feature-heading">Better&nbsp; power factor</h4>
          </div>
          <p className="v20-feature-desc">
            The power factory of the 5th generation of generation of electrostatic power source is <b>9% higher</b> than the any other high frequency&nbsp; at full load, and <b>29% higher</b> at half load
          </p>

          {/* Power Factor Table — unchanged */}
          <div className="v20-table-wrap">
            <table className="v20-table">
              <thead>
                <tr>
                  <th></th>
                  <th></th>
                  <th>Other High Frequency</th>
                  <th>Ador 5th Gen High Frequency</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="v20-td-rowlabel" rowSpan={2}>Power Factor</td>
                  <td className="v20-td-sublabel">Full Load</td>
                  <td>0.9</td>
                  <td>0.99</td>
                </tr>
                <tr>
                  <td className="v20-td-sublabel">Half Load</td>
                  <td>0.7</td>
                  <td>0.99</td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </section>

    </div>
  );
}